import { useQuery } from '@tanstack/react-query'
import { subscriptionApi } from '@/lib/api/subscription.api'

export function usePublicSubscriptionPlans() {
  return useQuery({
    queryKey: ['subscription-plans', 'public'],
    queryFn: () => subscriptionApi.getPublicPlans(),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
}
